<section class="static-content-wrapper">
	<div class="container">
		<div class="questions-wrapper">
			<div class="row">
				<div class="col-md-12" #top>
					<div class="title-container margin-bottom-20">
						<h3>FAQ<span>s</span></h3>
					</div>
				</div>
			</div>

			<div class="faq-index-group">
				<div class="group">
					<div class="faq-index">
						<p class="sub-title mb-2">GENERAL INFORMATION</p>
						<div class="faq-index-question">
							<ul>
								<li [ngxScrollTo]="g2">
									<p class="link">Is my information secure?</p>
								</li>
								<li
									[ngxScrollTo]="'g4'"
									*ngxPermissionsOnly="[USER_LEVEL.HUBBELL_ELIGIBLE, USER_LEVEL.HUBBELL_NOT_ELIGIBLE]">
									<p class="link">Where do I find my biometric screening results?</p>
								</li>
								<li [ngxScrollTo]="g5" *ngIf="getGlobalMfaStatus()">
									<p class="link">What is two-factor authentication (2FA)?</p>
								</li>
								<li [ngxScrollTo]="g6" *ngIf="getGlobalMfaStatus()">
									<p class="link">Why use 2FA?</p>
								</li>
								<li [ngxScrollTo]="g7" *ngIf="getGlobalMfaStatus()">
									<p class="link">How do I setup 2FA on myEHE?</p>
								</li>
								<li [ngxScrollTo]="g8" *ngIf="getGlobalMfaStatus()">
									<p class="link">What if I cannot access my e-mail on file?</p>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div class="group">
					<div class="faq-index">
						<p class="sub-title mb-2">THE EXAM EXPERIENCE</p>
						<div class="faq-index-question">
							<ul>
								<li [ngxScrollTo]="e1">
									<p class="link">How do I prepare for my EHE exam?</p>
								</li>
								<li [ngxScrollTo]="e2">
									<p class="link">Do I need to fast before my EHE exam?</p>
								</li>
								<li [ngxScrollTo]="e3">
									<p class="link">Why don't I need to fast?</p>
								</li>
								<li [ngxScrollTo]="e4">
									<p class="link">What tests are included in my visit?</p>
								</li>
								<li [ngxScrollTo]="e5">
									<p class="link">Are any of the tests optional?</p>
								</li>
								<li [ngxScrollTo]="e6">
									<p class="link">Will EHE Health write prescriptions for any medications I may need?</p>
								</li>
								<li [ngxScrollTo]="e7">
									<p class="link">Can EHE Health refer me to specialists?</p>
								</li>
								<li [ngxScrollTo]="e8">
									<p class="link">What about follow-up visits?</p>
								</li>
								<li [ngxScrollTo]="e9">
									<p class="multi-line-link">
										This is my first exam with EHE; will I be able to get a screening mammogram on the same day and at
										the same location?
									</p>
								</li>
								<li [ngxScrollTo]="e10">
									<p class="multi-line-link">
										I am a returning member to EHE and I prefer to get my screening mammogram on the same day and at the
										same location as my EHE Physical Exam; is this possible?
									</p>
								</li>
								<li [ngxScrollTo]="e11">
									<p class="multi-line-link">
										I had requested a Mammogram as the same day as my Physical Exam and have received a Pending
										Confirmation email; what does this mean?
									</p>
								</li>
								<li [ngxScrollTo]="e12">
									<p class="multi-line-link">
										I have requested a Mammogram as the same day as my Physical Exam but just received a cancellation
										email; what does this mean?
									</p>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<div class="group">
				<p class="sub-title">GENERAL INFORMATION</p>
				<div class="faq-block" #g2>
					<p class="faq-question">Is my information secure?</p>
					<div class="faq-answer">
						<p>
							Completely. EHE is committed to protecting your privacy and the security of all personal information. We
							use updated security technologies and procedures to shield your personal information from unauthorized
							access, use, or disclosure. We implement encryption processes to prevent third parties from reading or
							accessing any stored or transmitted information.
						</p>
						<div class="back-to-top">
							<p class="link" [ngxScrollTo]="top">Back to Top</p>
						</div>
					</div>
				</div>

				<div class="faq-block" #g5>
					<span *ngIf="getGlobalMfaStatus()">
						<p class="faq-question">What is two-factor authentication (2FA)?</p>
						<div class="faq-answer">
							<p>
								Two-factor authentication is an authentication process that requires two different authentication
								factors to establish identity. Usually, the first authentication factor is using a unique password along
								with a username. The second factor is receiving a time-based one-time password to the e-mail on file.
							</p>
							<div class="back-to-top">
								<p class="link" [ngxScrollTo]="top">Back to Top</p>
							</div>
						</div>
					</span>
				</div>

				<div class="faq-block" #g6>
					<span *ngIf="getGlobalMfaStatus()">
						<p class="faq-question">Why use 2FA?</p>
						<div class="faq-answer">
							<p>
								2FA is used to mitigate the threat of guessed or stolen credentials. Additionally, knowing when someone
								logs into your account can be helpful in identifying suspicious logins. 2FA notifies you as soon as
								someone unauthorized tries to login, because you receive an e-mail with 6 digit authentication code.
							</p>
							<div class="back-to-top">
								<p class="link" [ngxScrollTo]="top">Back to Top</p>
							</div>
						</div>
					</span>
				</div>

				<div class="faq-block" #g7>
					<span *ngIf="getGlobalMfaStatus()">
						<p class="faq-question">How do I setup 2FA on myEHE?</p>
						<div class="faq-answer">
							<p>
								Existing members will be prompted with the 2FA opt-in screen upon logging onto the myEHE. Members who
								opt-in will receive a time sensitive 6 digit authentication code on the e-mail we have on file. Members
								will be authenticated after entering the 6 digit code and will be navigated to the myEHE homepage.
								Please note that, you can opt out of 2FA by clicking the dropdown under the member name/icon and click
								on My Account.
							</p>
							<div class="back-to-top">
								<p class="link" [ngxScrollTo]="top">Back to Top</p>
							</div>
						</div>
					</span>
				</div>

				<div class="faq-block" #g8>
					<span *ngIf="getGlobalMfaStatus()">
						<p class="faq-question">What if I cannot access my e-mail on file?</p>
						<div class="faq-answer">
							<p>
								If you need to book your physical exam, please click on "Book Your Exam" and enter your first name, last
								name, and date of birth to confirm your eligibility. For any email-related inquiries, please contact
								your company's technical team.
							</p>
							<div class="back-to-top">
								<p class="link" [ngxScrollTo]="top">Back to Top</p>
							</div>
						</div>
					</span>
				</div>

				<div
					class="faq-block"
					id="g4"
					*ngxPermissionsOnly="[USER_LEVEL.HUBBELL_ELIGIBLE, USER_LEVEL.HUBBELL_NOT_ELIGIBLE]">
					<p class="faq-question">Where do I find my biometric screening results?</p>
					<div class="faq-answer">
						<p>
							Go to the navigation bar at the top of the site. Depending on your status, you will see either Health
							Portfolio or Biometric Screening Results.
						</p>
						<p>
							If you see Health Portfolio in the navigation bar, select it and then click the Health Documents tab. You
							can select Biometric Screening Result from the left side to access your full report.
						</p>
						<p>
							If you see Biometric Screening Results in the navigation bar, select it and you will be able to open your
							full report.
						</p>
						<div class="back-to-top">
							<p class="link" [ngxScrollTo]="top">Back to Top</p>
						</div>
					</div>
				</div>
			</div>

			<div class="group">
				<p class="sub-title">THE EXAM EXPERIENCE</p>
				<div class="faq-block" #e1>
					<p class="faq-question">How do I prepare for my EHE exam?</p>
					<div class="faq-answer">
						<p>
							<a class="link" href="{{ prepInstructions }}" target="_blank">Click here</a>
							to see full preparation instructions.
						</p>
						<div class="back-to-top">
							<p class="link" [ngxScrollTo]="top">Back to Top</p>
						</div>
					</div>
				</div>

				<div class="faq-block" #e2>
					<p class="faq-question">Do I need to fast before my EHE exam?</p>
					<div class="faq-answer">
						<p>
							Only if you are over 50 and scheduled for a cardiovascular screening. We'll give you simple instructions
							for preparing, including what to wear.
						</p>
						<div class="back-to-top">
							<p class="link" [ngxScrollTo]="top">Back to Top</p>
						</div>
					</div>
				</div>

				<div class="faq-block" #e3>
					<p class="faq-question">Why don't I need to fast?</p>
					<div class="faq-answer">
						<p>
							EHE follows the most up-to-date guidelines recommended by the U.S. Preventive Services Task Force,
							American Heart Association, and American Diabetes Association. Non-fasting blood tests are just as
							accurate when it comes to diagnosing high cholesterol and diabetes.
						</p>
						<div class="back-to-top">
							<p class="link" [ngxScrollTo]="top">Back to Top</p>
						</div>
					</div>
				</div>

				<div class="faq-block" #e4>
					<p class="faq-question">What tests are included in my visit?</p>
					<div class="faq-answer">
						<p>All the screenings are clinically indicated for your needs and risks. This includes:</p>
						<ul>
							<li>Standard measurements, such as vital signs and body composition.</li>
							<li>
								Screenings & risk assessments, including a cardiorespiratory test, mental health evaluation, and
								vision/hearing screenings.
							</li>
							<li>Lab work to test cholesterol levels, blood sugar, and more.</li>
							<li>Additional follow-ups, such as a screening mammogram, bone density scan, and colonoscopy.</li>
						</ul>
						<div class="back-to-top">
							<p class="link" [ngxScrollTo]="top">Back to Top</p>
						</div>
					</div>
				</div>

				<div class="faq-block" #e5>
					<p class="faq-question">Are any of the tests optional?</p>
					<div class="faq-answer">
						<p>
							Of course. We give you the opportunity to experience our full range of the latest preventive screenings,
							as well as age and gender appropriate evaluations for heart health, cancer, mental health, and other
							risks. Each EHE Health visit is personalized for you, and you can opt out of certain offerings if you
							prefer.
						</p>
						<div class="back-to-top">
							<p class="link" [ngxScrollTo]="top">Back to Top</p>
						</div>
					</div>
				</div>

				<div class="faq-block" #e6>
					<p class="faq-question">Will EHE Health write prescriptions for any medications I may need?</p>
					<div class="faq-answer">
						<p>
							EHE Health provides preventive health, but not prescriptive pharmaceutical treatment. Your medications
							will be managed by your primary care physician or a specialist.
						</p>
						<div class="back-to-top">
							<p class="link" [ngxScrollTo]="top">Back to Top</p>
						</div>
					</div>
				</div>

				<div class="faq-block" #e7>
					<p class="faq-question">Can EHE Health refer me to specialists?</p>

					<div class="faq-answer">
						<p>
							If our physician identifies a health concern that requires examination by a specialist, we can coordinate
							a referral for you. EHE Health can also help you find a primary care physician if you do not have one.
						</p>
						<div class="back-to-top">
							<p class="link" [ngxScrollTo]="top">Back to Top</p>
						</div>
					</div>
				</div>

				<div class="faq-block" #e8>
					<p class="faq-question">What about follow-up visits?</p>
					<div class="faq-answer">
						<p>
							While most patients are eligible for the full comprehensive health exam once per enrollment period, our
							physician-led expert medical team and health mentorship program are included in your EHE Health benefit
							and available as part of your year-round prevention program.You'll even be able to come back to track your
							progress with health goals like weight loss or lowering your cholesterol.
						</p>
						<div class="back-to-top">
							<p class="link" [ngxScrollTo]="top">Back to Top</p>
						</div>
					</div>
				</div>

				<div class="faq-block" #e9>
					<p class="faq-question">
						This is my first exam with EHE; will I be able to get a screening mammogram on the same day and at the same
						location?
					</p>
					<div class="faq-answer">
						<p class="mb-2">Great job booking your first EHE Preventive Health Exam!</p>
						<p>
							During your Physical Exam, your EHE Provider will assess your lifetime risk of breast cancer. For women
							above ages 40 years, a screening mammogram may be recommended as part of establishing a baseline or as
							part of their continued screening process. If this is your first time at EHE, we recommend you meet with
							your EHE provider to discuss your medical and family history & understand your risks. The screening
							mammogram can then be scheduled as part of your post-exam services.
						</p>
						<div class="back-to-top">
							<p class="link" [ngxScrollTo]="top">Back to Top</p>
						</div>
					</div>
				</div>

				<div class="faq-block" #e10>
					<p class="faq-question">
						I am a returning member to EHE and I prefer to get my screening mammogram on the same day and at the same
						location as my EHE Physical Exam; is this possible?
					</p>
					<div class="faq-answer">
						<p class="mb-2">
							Most of our partner radiology facilities are co-located or within driving distance from your PE provider.
						</p>
						<p class="mb-2">
							You may request a mammogram along with your EHE Physical Exam; when doing so, we ask that you request for
							a mammogram at least 10 days in advance so we can work to coordinate and confirm with our radiology
							partner.
						</p>
						<p class="mb-1">Please note:</p>
						<ul>
							<li>
								The radiology partners may be on-site at your EHE provider OR at a different service location that may
								require some travel time.
							</li>
							<li>
								The availability of your mammogram appointment depends upon the appointment availability & travel time
								to the contracted radiology partners.
							</li>
						</ul>
						<p>
							Please contact us at
							<a
								class="link"
								href="mailto:EHEAppointmentManager@ehe.health"
								appEheAnalytics
								[data]="{
									pageUrl: '/faq/questions',
									redirectedTo: '/faq/questions',
									componentName: 'faq',
									id: 'faq exam experience',
									placement: 'faq'
								}">
								<div class="clickable font-normal">
									<span [translate]="'EHEAppointmentManager@ehe.health'" class="pr-1">
										EHEAppointmentManager&#64;ehe.health
									</span>
								</div>
							</a>
							if you have not received a confirmation within a week of your upcoming EHE Physical Exam.
						</p>
						<div class="back-to-top">
							<p class="link" [ngxScrollTo]="top">Back to Top</p>
						</div>
					</div>
				</div>

				<div class="faq-block" #e11>
					<p class="faq-question">
						I had requested a Mammogram as the same day as my Physical Exam and have received a Pending Confirmation
						email; what does this mean?
					</p>
					<div class="faq-answer">
						<p>
							The team has received your request for the Mammogram screening for the same day as your Physical Exam. We
							are working with our radiology partner to confirm this appointment time for you; please look out for an
							email from EHE on next steps. Please contact us at
							<a
								class="link"
								href="mailto:EHEAppointmentManager@ehe.health"
								appEheAnalytics
								[data]="{
									pageUrl: '/faq/questions',
									redirectedTo: '/faq/questions',
									componentName: 'faq',
									id: 'faq exam experience',
									placement: 'faq'
								}">
								<div class="clickable font-normal">
									<span [translate]="'EHEAppointmentManager@ehe.health'" class="pr-1">
										EHEAppointmentManager&#64;ehe.health
									</span>
								</div>
							</a>
							if you have not received a confirmation within a week of your upcoming EHE Physical.
						</p>
						<div class="back-to-top">
							<p class="link" [ngxScrollTo]="top">Back to Top</p>
						</div>
					</div>
				</div>

				<div class="faq-block" #e12>
					<p class="faq-question">
						I have requested a Mammogram as the same day as my Physical Exam but just received a cancellation email;
						what does this mean?
					</p>
					<div class="faq-answer">
						<p>
							We apologize that we were not able to accommodate your request for a mammogram on the same day as your EHE
							Physical Exam. Please read carefully through the cancellation email:
							<b>Cancellation of the mammogram appointment does NOT impact your EHE Physical Exam appointment.</b>
							Our scheduling team will be working to accommodate an appointment for you after the EHE Physical Exam at
							your convenience.
						</p>
						<div class="back-to-top">
							<p class="link" [ngxScrollTo]="top">Back to Top</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
